import { isFeatureEnabled } from "../utils/featureFlags";
import { getTenantContext } from "../utils/tenantContext";

const QUEUE_KEY = "norm_audit_events_queue";

function getQueue() {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function setQueue(items) {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(items.slice(-200)));
  } catch (e) {}
}

async function postOne(event) {
  const { tenantKey, workspaceKey } = getTenantContext();
  const resp = await fetch("/api/audit-events", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Norm-Tenant": tenantKey,
      "X-Norm-Workspace": workspaceKey,
    },
    body: JSON.stringify({ event, tenantKey, workspaceKey }),
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(txt || "Failed to persist audit event");
  }
}

export async function flushQueuedAuditEvents() {
  if (!isFeatureEnabled("auditTrailServerSyncEnabled")) return;
  const queue = getQueue();
  if (queue.length === 0) return;
  const remaining = [];
  for (const item of queue) {
    try {
      await postOne(item);
    } catch (e) {
      remaining.push(item);
    }
  }
  setQueue(remaining);
}

export async function persistAuditEvent(event) {
  if (!isFeatureEnabled("auditTrailServerSyncEnabled")) return;
  try {
    await postOne(event);
    await flushQueuedAuditEvents();
  } catch (e) {
    const queue = getQueue();
    queue.push(event);
    setQueue(queue);
  }
}

